import isPropValid from "@emotion/is-prop-valid";
import { margin } from "polished";

import { ResponsiveArgs, MarginOptions } from "./types";

export const filterColorProp = {
  shouldForwardProp: (prop: string) => isPropValid(prop) && prop !== "color",
};

export const generateMargins = (
  margins?: MarginOptions,
): Partial<ResponsiveArgs> => {
  // Convert our object responsive values using polished margin
  if (!margins) return {};
  const polishedMargins = {};

  for (const property in margins) {
    polishedMargins[property] = margin(...margins[property]);
  }

  return polishedMargins;
};
